import moment from 'moment';
import * as Yup from 'yup';

import {
  INSURANCE_FORM_NAME_MIN_LENGTH,
  INSURANCE_FORM_PHONE_LENGTH,
  INSURANCE_FORM_TEXT_MIN_LENGTH,
  INSURANCE_FORM_LAST_NAME_MIN_LENGTH,
  INSURANCE_FORM_CITY_MIN_LENGTH,
  INSURANCE_FORM_ZIP_LENGTH,
} from './constants';

export const INSURANCE_FORM_SCHEMA = Yup.object({
  insurance_name: Yup.string()
    .min(
      INSURANCE_FORM_TEXT_MIN_LENGTH,
      `Insurance name must be at least ${INSURANCE_FORM_TEXT_MIN_LENGTH} characters`,
    )
    .required('Insurance name is required'),
  relationship_to_policyholder: Yup.string().required('Relationship to policyholder is required'),
  member_first_name: Yup.string()
    .min(
      INSURANCE_FORM_NAME_MIN_LENGTH,
      `Member first name must be at least ${INSURANCE_FORM_NAME_MIN_LENGTH} characters`,
    )
    .required('Member first name is required'),
  member_last_name: Yup.string()
    .min(
      INSURANCE_FORM_LAST_NAME_MIN_LENGTH,
      `Member last name must be at least ${INSURANCE_FORM_LAST_NAME_MIN_LENGTH} characters`,
    )
    .required('Member last name is required'),
  insurance_start_date: Yup.mixed()
    .required('Insurance start date is required')
    .test(
      'before-or-equal-end',
      'Insurance start date cannot be after insurance end date',
      function insuranceStartBeforeEnd(value) {
        const end = this.parent.insurance_end_date;
        if (!moment.isMoment(value) || !moment.isMoment(end)) return true;
        return !value.isAfter(end, 'day');
      },
    ),
  insurance_end_date: Yup.mixed()
    .required('Insurance end date is required')
    .test(
      'after-or-equal-start',
      'Insurance end date cannot be before insurance start date',
      function insuranceEndAfterStart(value) {
        const start = this.parent.insurance_start_date;
        if (!moment.isMoment(value) || !moment.isMoment(start)) return true;
        return !value.isBefore(start, 'day');
      },
    ),
  member_id: Yup.string()
    .min(
      INSURANCE_FORM_TEXT_MIN_LENGTH,
      `Member ID must be at least ${INSURANCE_FORM_TEXT_MIN_LENGTH} characters`,
    )
    .required('Member ID is required'),
  group_number: Yup.string(),
  member_street_address_line_one: Yup.string()
    .min(
      INSURANCE_FORM_TEXT_MIN_LENGTH,
      `Street address line one must be at least ${INSURANCE_FORM_TEXT_MIN_LENGTH} characters`,
    )
    .required('Street address line one is required'),
  member_street_address_line_two: Yup.string(),
  member_street_address_city: Yup.string()
    .min(
      INSURANCE_FORM_CITY_MIN_LENGTH,
      `City must be at least ${INSURANCE_FORM_CITY_MIN_LENGTH} characters`,
    )
    .required('City is required'),
  member_street_address_state: Yup.string().required('State is required'),
  member_street_address_zip: Yup.string()
    .length(
      INSURANCE_FORM_ZIP_LENGTH,
      `ZIP code must be exactly ${INSURANCE_FORM_ZIP_LENGTH} characters`,
    )
    .required('ZIP code is required'),
  policyholder_first_name: Yup.string()
    .min(
      INSURANCE_FORM_NAME_MIN_LENGTH,
      `Policyholder first name must be at least ${INSURANCE_FORM_NAME_MIN_LENGTH} characters`,
    )
    .required('Policyholder first name is required'),
  policyholder_last_name: Yup.string()
    .min(
      INSURANCE_FORM_LAST_NAME_MIN_LENGTH,
      `Policyholder last name must be at least ${INSURANCE_FORM_LAST_NAME_MIN_LENGTH} characters`,
    )
    .required('Policyholder last name is required'),
  policyholder_date_of_birth: Yup.mixed().required('Policyholder date of birth is required'),
  policyholder_phone: Yup.string()
    .length(
      INSURANCE_FORM_PHONE_LENGTH,
      `Phone must be exactly ${INSURANCE_FORM_PHONE_LENGTH} characters`,
    )
    .required('Policyholder phone is required'),
  policyholder_gender: Yup.string().required('Policyholder gender is required'),
  policyholder_address_same_as_member: Yup.boolean(),
  policyholder_street_address_line_one: Yup.string()
    .min(
      INSURANCE_FORM_TEXT_MIN_LENGTH,
      `Street address line one must be at least ${INSURANCE_FORM_TEXT_MIN_LENGTH} characters`,
    )
    .required('Street address line one is required'),
  policyholder_street_address_line_two: Yup.string(),
  policyholder_street_address_city: Yup.string()
    .min(
      INSURANCE_FORM_CITY_MIN_LENGTH,
      `City must be at least ${INSURANCE_FORM_CITY_MIN_LENGTH} characters`,
    )
    .required('City is required'),
  policyholder_street_address_state: Yup.string().required('State is required'),
  policyholder_street_address_zip: Yup.string()
    .length(
      INSURANCE_FORM_ZIP_LENGTH,
      `ZIP code must be exactly ${INSURANCE_FORM_ZIP_LENGTH} characters`,
    )
    .required('ZIP code is required'),
});
